import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "src/app-redux/hooks";
import { getAllMultiContainerGateDocuments } from "src/app-redux/vehicle/actions/vehicleActions";
import { selectVehicleDetails } from "src/app-redux/vehicle/vehicleSlice";
import { useStyles } from "./../style";
import IconButton from "@mui/material/IconButton";
import img from "src/assets/images/file_formats_logos/img.svg";
import doc from "src/assets/images/file_formats_logos/doc.svg";
import pdf from "src/assets/images/file_formats_logos/pdf.svg";
import xlsx from "src/assets/images/file_formats_logos/xlsx.svg";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { downloadFile } from "src/app-redux/common-actions";

export interface IDrawerDetailsProps {}

export default function DrawerDetails(props: IDrawerDetailsProps) {
  const classes = useStyles();
  // Redux
  const vehicleDetailsResponse: any = useAppSelector(selectVehicleDetails);
  const dispatch = useDispatch();
  const [allDocs, setAllDocs] = useState<any[]>([]);

  useEffect(() => {
    vehicleDetailsResponse?.vehicleDetail?.vehicleId && getPictureGalleryContent();
  }, [vehicleDetailsResponse]);

  const getPictureGalleryContent = async () => {
    const res: any = await dispatch(
      getAllMultiContainerGateDocuments({
        gatePassId: vehicleDetailsResponse?.vehicleDetail?.vehicleId,
      })
    );
    if (res.payload) setAllDocs(res.payload);
  };

  const downloadDocument = async (item: any) => {
    const type =
      item.fileCategory === "Scan"
        ? 2
        : item.fileCategory === "Weight"
        ? 3
        : item.fileCategory === "Commercial"
        ? 4
        : 1;
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-gate-doc-by-id/${item.id}?docType=${type}`,
      contentType: ".jpg",
      fileName: item.title,
    };
    dispatch(downloadFile(fileMetaData));
  };

  const remarks = (remarks: any) => {
    const remarksArray = remarks.split("@``@");
    const notesElements = remarksArray?.map((value: any, index: number) => (
      <>
        <div key={index}>{value ? value : ""}</div>
        {index !== remarksArray.length - 1 && remarksArray[0].length > 1 && <br />}
      </>
    ));

    return notesElements;
  };

  return (
    <div className={classes.drawerDetails}>
      {/* Container Details */}
      <Typography className="heading">Container Details </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Container Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.containerNumber
                ? vehicleDetailsResponse.vehicleDetail?.containerNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Container Seal Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.sealNo
                ? vehicleDetailsResponse.vehicleDetail?.sealNo
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Bill Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.billNo
                ? vehicleDetailsResponse.vehicleDetail?.billNo
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">VIR Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.virNo
                ? vehicleDetailsResponse.vehicleDetail?.virNo
                : "-"}
            </Typography>
          </Grid>
        </Grid>

        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Good’s Declaration Number (GD#)</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.gdNo
                ? vehicleDetailsResponse.vehicleDetail?.gdNo
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Vessel</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.vessel
                ? vehicleDetailsResponse.vehicleDetail?.vessel
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Container Size</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.containerSize
                ? vehicleDetailsResponse.vehicleDetail?.containerSize
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Container Type</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.containerType
                ? vehicleDetailsResponse.vehicleDetail?.containerType
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Container Load Type</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.containerLoadType
                ? vehicleDetailsResponse.vehicleDetail?.containerLoadType
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Movement</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.movement
                ? vehicleDetailsResponse.vehicleDetail?.movement
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Ro Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.roNumber
                ? vehicleDetailsResponse.vehicleDetail?.roNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Activity</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.activity
                ? vehicleDetailsResponse.vehicleDetail?.activity
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Cost Center</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.costCenter
                ? vehicleDetailsResponse.vehicleDetail?.costCenter
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Sub Line</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.subLine
                ? vehicleDetailsResponse.vehicleDetail?.subLine
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Line</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.line
                ? vehicleDetailsResponse.vehicleDetail?.line
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Cash Client</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.cashClient
                ? vehicleDetailsResponse.vehicleDetail?.cashClient
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Client</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.client
                ? vehicleDetailsResponse.vehicleDetail?.client
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Shipper</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.shipper
                ? vehicleDetailsResponse.vehicleDetail?.shipper
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">LP/ Booking No</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.bookingNumber
                ? vehicleDetailsResponse.vehicleDetail?.bookingNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Transporter</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.transporter
                ? vehicleDetailsResponse.vehicleDetail?.transporter
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Consignee</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.consignee
                ? vehicleDetailsResponse.vehicleDetail?.consignee
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Previous Location</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.previousLocation
                ? vehicleDetailsResponse.vehicleDetail?.previousLocation
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">C&F Agent</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.cfAgent
                ? vehicleDetailsResponse.vehicleDetail?.cfAgent
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Destination</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.destination
                ? vehicleDetailsResponse.vehicleDetail?.destination
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Voyage</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.voyage
                ? vehicleDetailsResponse.vehicleDetail?.voyage
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Discharge Port</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.dischargePort
                ? vehicleDetailsResponse.vehicleDetail?.dischargePort
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Doc Ref Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.docRefNumber
                ? vehicleDetailsResponse.vehicleDetail?.docRefNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Shift</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.shift
                ? vehicleDetailsResponse.vehicleDetail?.shift
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Pol</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.pol
                ? vehicleDetailsResponse.vehicleDetail?.pol
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">SCAC Code</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.scacCode
                ? vehicleDetailsResponse.vehicleDetail?.scacCode
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Apply Storage</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.applyStorage ? "Yes" : "No"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Charges Amount</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.chargesAmount
                ? vehicleDetailsResponse.vehicleDetail?.chargesAmount
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Charges Status</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.chargesStatus
                ? vehicleDetailsResponse.vehicleDetail?.chargesStatus
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Previous Remarks</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.previousRemarks
                ? vehicleDetailsResponse.vehicleDetail?.previousRemarks
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">EIR Remarks</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.eirRemarks
                ? vehicleDetailsResponse.vehicleDetail?.eirRemarks
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Forwarder</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.forwarder
                ? vehicleDetailsResponse.vehicleDetail?.forwarder
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Container Gross Weight</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.containerGrossWeight
                ? vehicleDetailsResponse.vehicleDetail?.containerGrossWeight
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">NLC Seal Number:</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.nlcSealNo
                ? vehicleDetailsResponse.vehicleDetail?.nlcSealNo
                : "-"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Driver Details */}
      <Typography className="heading">Driver Details </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Driver Name</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.driverName
                ? vehicleDetailsResponse.vehicleDetail?.driverName
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Driver’s Father Name</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.driverFatherName
                ? vehicleDetailsResponse.vehicleDetail?.driverFatherName
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Driver’s Mobile Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.driverMobileNumber
                ? vehicleDetailsResponse.vehicleDetail?.driverMobileNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Driver’s CNIC</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.driverCNIC
                ? vehicleDetailsResponse.vehicleDetail?.driverCNIC
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Travelling Doc Type</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.travellingDocType
                ? vehicleDetailsResponse.vehicleDetail?.travellingDocType
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Travelling Doc Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.travellingDocNumber
                ? vehicleDetailsResponse.vehicleDetail?.travellingDocNumber
                : "-"}
            </Typography>
          </Grid>
        </Grid>

        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">NTN</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.driverNTN
                ? vehicleDetailsResponse.vehicleDetail?.driverNTN
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Resident</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.driverResident
                ? vehicleDetailsResponse.vehicleDetail?.driverResident
                : "-"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Cargo Information */}
      <Typography className="heading">Cargo Information </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Type Of Consignment</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.consignmentTypeName
                ? vehicleDetailsResponse.vehicleDetail?.consignmentTypeName
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Type Of Cargo</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.cargoTypeName
                ? vehicleDetailsResponse.vehicleDetail?.cargoTypeName
                : "-"}
            </Typography>
          </Grid>
        </Grid>

        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Good’s Declaration Number (GD#)</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.gdNo
                ? vehicleDetailsResponse.vehicleDetail?.gdNo
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">GD Date</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.gdDate
                ? moment(new Date(vehicleDetailsResponse.vehicleDetail?.gdDate)).format(
                    "DD-MM-YYYY"
                  )
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Supplier Name</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.supplierName
                ? vehicleDetailsResponse.vehicleDetail?.supplierName
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">WeBOC ID (IGM#)</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.webBocId
                ? vehicleDetailsResponse.vehicleDetail?.webBocId
                : "-"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Others */}
      <Typography className="heading">Others </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Entry Date and Time</Typography>
            <Typography className="subHeadingDetails">
              {moment(new Date(vehicleDetailsResponse.vehicleDetail?.dateTime)).format(
                "DD-MM-YYYY hh:mm A"
              )}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Gate-in Remarks</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.notes ? (
                <>{remarks(vehicleDetailsResponse.vehicleDetail?.notes)} </>
              ) : (
                "-"
              )}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Customs Inspector Remarks</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.remarks
                ? vehicleDetailsResponse.vehicleDetail?.remarks
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Gate-out Remarks</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.gateOutComments
                ? vehicleDetailsResponse.vehicleDetail?.gateOutComments
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">WeBOC Vehicle Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.webocVehicleNumber
                ? vehicleDetailsResponse.vehicleDetail?.webocVehicleNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}></Grid>
        </Grid>
      </Grid>

      {/* Picture Gallery */}
      <Typography className="heading">All Documents </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow" spacing={2}>
          <Grid
            item
            md={12}
            id="main-div"
            className={classes.drawerDetails}
            style={{
              height: "max-content",
            }}
          >
            <Grid container direction="row">
              {/* History Item  */}
              {allDocs.length !== 0 ? (
                allDocs.map((item: any) => (
                  <Grid md={6} key={item.id} style={{ padding: "5px" }}>
                    <Grid container direction="row" className="itemRowTrail">
                      <Grid md={3} style={{ padding: "5px" }}>
                        <img
                          src={
                            item.extension === "doc" || item.extension === "docx"
                              ? doc
                              : item.extension === "jpg" ||
                                item.extension === "jpeg" ||
                                item.extension === "png"
                              ? img
                              : item.extension === "pdf"
                              ? pdf
                              : item.extension === "xlsx"
                              ? xlsx
                              : img
                          }
                          alt={item.extension}
                          width="25px"
                        />
                      </Grid>
                      <Grid md={6}>
                        <Typography className="subHeading itemName">
                          {item.originalFileName}
                        </Typography>
                      </Grid>
                      <Grid md={2}>
                        <IconButton
                          onClick={() => {
                            downloadDocument(item);
                          }}
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Grid>
                ))
              ) : (
                <div></div>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* <Grid container spacing={2} className="topContainer">
        <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
          {getItems()}
        </LightGallery>
      </Grid> */}
    </div>
  );
}
